module.exports = "/_next/static/images/pk-c02a99894927afb1b364a99d6ed4a019.svg";